import { localise } from '../lang/lang';
export const getCreatorName = (archivedUserAware) => {
    if (archivedUserAware.archived_creator) {
        return `${archivedUserAware.archived_creator.full_name} (${localise('DELETED_ACCOUNT')})`;
    }
    if (archivedUserAware.creator) {
        return archivedUserAware.creator.full_name;
    }
    return localise('DELETED_ACCOUNT');
};
